import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useJobApplicants } from './job-applicants-provider';

function JobApplicantsHeaderView({}: {}) {
   const { t } = useTranslation('global');
   const jobApplicants = useJobApplicants();
   return (
      <section className="MyProfileTopSection">
         <div className="MYProfileHeader">
            <div className="MyProfileDetails">
               <h6 className="mb-2">
                  {t('employerInnerAccountdetail.user')}
                  {': '}
                  <span className="fw-bold">
                     {jobApplicants.userDetails?.first_name} {jobApplicants.userDetails?.last_name}
                  </span>
               </h6>
               <h6 className="mb-4">
                  {t('employerInnerAccountdetail.companyName')}
                  {': '}
                  <span className="fw-bold">{jobApplicants.jobInfo?.company_name}</span>
               </h6>
               <h6>
                  {'Використаний пакет:'}{' '}
                  <span className="fw-bold">{jobApplicants.planDetails}</span>
               </h6>
            </div>
            <Link to="/plans/purchase" className="btn button1 mt-4 mt-sm-0">
               {t('employerInnerAccountdetail.upgradePlan')}
            </Link>
         </div>
      </section>
   );
}

export const JobApplicantsHeader = observer(JobApplicantsHeaderView);
